//UserFlowSlice.js

import { createSlice } from '@reduxjs/toolkit'
import { fetchUserFlowByAppId, fetchUserFlowById } from '../thunks/userFlowThunk'
import { logout } from './UserAuthSlice'
import { resetOtherStateAfterLogin } from './UserAuthSlice'

const initialState = {
	hasMore: false,
	appId: '',
	count: '',
	limit: 2,
	skip: 0,
	userFlowsByAppId: [],
	selectedFlow: {}, //{flowId: '1', userFlowByID: from api}
}


const UserFlowSlice = createSlice({
	name:"userflow",
	initialState,
	reducers: {
		updateSelectedFlow: (state, action) => {
			//console.log("updateSelectedFlow action", action)
			// state.selectedFlow = {
			// 	flowId: action.payload, //has the payload i.e. flowId user clicked
			// 	 flow: state.userFlowsByAppId.find((flow) => {
    		// 	 	return flow.id === action.payload
			// 	})
			// }

			state.selectedFlow = action.payload
		},
		resetUserFlowsByAppId: (state, action) => {
			//console.log("resetUserFlowsByAppId action", action)
			state.userFlowsByAppId = []
			state.hasMore = false
			state.skip = 0
		},

	},
	extraReducers(builder){
		builder.addCase(fetchUserFlowByAppId.fulfilled, (state, action) => {
     	//console.log("slice",action.payload.data.userFlowByAppId.userflow)
     	//console.log("slice",action.meta.arg.skip)
     	state.skip = action.meta.arg.skip,
		state.hasMore = action.payload.data.userFlowByAppId.hasMore,
		state.appId = action.meta.arg.idfromURL,
		state.count = action.payload.data.userFlowByAppId.count,
		state.userFlowsByAppId = state.userFlowsByAppId.concat(action.payload.data.userFlowByAppId.userflow)
    });
	builder.addCase(fetchUserFlowById.fulfilled, (state, action) => {
     //console.log("fetchUserFlowById", action.payload.data.userFlowId)
      // state.selectedFlow = {
	// 			flowId: action.meta.arg, 
	// 			 flow: action.payload.data.userFlowId
	// 		}

		state.selectedFlow = action.payload.data.userFlowId

    });
	builder.addCase(logout, (state, action) => {
		//console.log("logout")
		return initialState
	})	
	builder.addCase(resetOtherStateAfterLogin, (state, action) => {
		//console.log("resetOtherStateAfterLogin")
		return initialState
	})
	}
})


export const { updateSelectedFlow, resetUserFlowsByAppId } = UserFlowSlice.actions;
export const useFlowReducer = UserFlowSlice.reducer;